import { attributesImageSchema } from "./attributes.js";
import { validate } from "../../helpers/validate.js";
import { guideImageHtml } from "../../elements/image/component.js";
import { ScalarImageVue } from "./component.js";
import { hydrate } from "./hydration.js";
const scalarImage = {
  name: "scalar-image",
  tagName: "scalar-image",
  tiptapName: "custom_image",
  attributeTransform: (content, attrs) => {
    const validated = validate(attributesImageSchema, {
      ...attrs,
      caption: attrs.caption || content,
      ...(attrs.width || attrs.height) && { size: "custom" }
    });
    return validated;
  },
  render: async (props) => {
    const transformed = scalarImage.attributeTransform("", props);
    return transformed ? guideImageHtml(transformed) : "";
  },
  hydrate
};
export {
  ScalarImageVue,
  scalarImage
};
//# sourceMappingURL=index.js.map
